<!--
@component
The Rect component needs to be placed either inside a svelte-konva Layer or Group component. 

### Usage:
```tsx
<Rect config={{ x: 100, y: 100, width: 100, height: 50, fill: "blue" }} />
```

### Static config:
By default svelte-konva will automatically update your config prop on `dragend` and `transformend` events to match the config state (position, rotation, scale, ...) with the internal Konva state. 
If you additionally bind the config prop your reactive blocks will also be triggered once this happens. 
There might be cases where this behavior is not beneficial in this case you can disable it by passing the `staticConfig = true` prop to the component.

Further information: [Konva API docs](https://konvajs.org/api/Konva.Rect.html), [svelte-konva docs](https://konvajs.org/docs/svelte)
-->
<script>/**
 * WARNING: This component is autogenerated using the svelteKonvaComponent.hbs template. Do not edit this file manually!
 */
import Konva from 'konva';
import { onMount, onDestroy, createEventDispatcher } from 'svelte';
import { registerEvents } from './util/events';
import { getParentContainer } from './util/manageContext';
import { copyExistingKeys } from './util/object';
export let config;
export let handle = new Konva.Rect(config);
export let staticConfig = false;
let parent = getParentContainer();
let dispatcher = createEventDispatcher();
$: handle.setAttrs(config);
onMount(() => {
    $parent.add(handle);
    if (!staticConfig) {
        handle.on('transformend', () => {
            copyExistingKeys(config, handle.getAttrs());
            config = config;
        });
        handle.on('dragend', () => {
            copyExistingKeys(config, handle.getAttrs());
            config = config;
        });
    }
    registerEvents(dispatcher, handle);
});
onDestroy(() => {
    handle.destroy();
});
</script>
